/* VAXA product image behaviour.

   The hover magnifier that used to live here was REMOVED on 2026-08-08 at
   Mohamed's request. It is gone rather than disabled by a flag, but the file
   itself is kept (and still loaded from vaxa-tokens.liquid) because it does a
   second, unrelated job that is still wanted:

   On the home page the featured product sits inside Dawn's <modal-opener>, so a
   click pops a lightbox carousel of every product photo. Solomon asked for the
   home page to show ONE standard picture, so that click is suppressed. Deleting
   this file would quietly bring the 9-photo carousel back.

   The product page gallery is deliberately left alone: the lightbox is correct
   there.

   If the magnifier is ever wanted again, it was a 150px lens at 2.4x built on
   mousemove over .product__media, pulling a width=1800 rendition from the CDN. */
(function () {
  if (window.__vxZoom) return;
  window.__vxZoom = true;

  var HOME_SCOPE = '.section-featured-product';

  function silenceLightbox(opener) {
    if (opener.dataset.vxSilenced) return;
    opener.dataset.vxSilenced = '1';
    opener.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    }, true);
    opener.querySelectorAll('button,[role="button"]').forEach(function (b) {
      b.setAttribute('tabindex', '-1');
      b.setAttribute('aria-hidden', 'true');
    });
  }

  function boot() {
    document.querySelectorAll('.product__media').forEach(function (m) {
      var opener = m.closest('modal-opener');
      if (opener && m.closest(HOME_SCOPE)) silenceLightbox(opener);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  setTimeout(boot, 1200);
})();
